import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BatchJobDialog } from './batch-job-dialog/batch-job-dialog.component';
import { FileBrowserDialog } from './file-browser/file-browser-dialog.component';
import { GearAccessDialogComponent } from './gear-access-dialog/gear-access-dialog.component';
import { GearConfigComponent } from './gear-config/gear-config.component';
import { GearInfoComponent } from './gear-info/gear-info.component';
import { GearVersionSelectorComponent } from './gear-version-selector/gear-version-selector.component';
import { GearService } from './gear.service';
import { MaterialModule } from '../material.module';
import { RunGearDialog } from './run-gear-dialog/run-gear-dialog.component';
import { SelectGearDialog } from './select-gear-dialog/select-gear-dialog.component';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import {
  FwIconModule,
  FwPopoverModule,
  FwProgressModule,
  FwSelectMenuModule,
  FwTextInputModule,
} from '@flywheel-io/vision';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FwIconModule,
    FwPopoverModule,
    FwProgressModule,
    FwSelectMenuModule,
    FwTextInputModule,
    MaterialModule,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [
    BatchJobDialog,
    FileBrowserDialog,
    GearAccessDialogComponent,
    GearConfigComponent,
    GearInfoComponent,
    GearVersionSelectorComponent,
    RunGearDialog,
    SelectGearDialog,
  ],
  providers: [
    GearService,
  ],
})
export class GearModule { }
